import { BillingMode } from '../../../../services/exports/Constants';

export default {
  billing_modes: {
    [BillingMode.Stripe]: 'Mode de paiement',
    [BillingMode.InternalInvoicing]: 'Versements',
  },
};
